import { Button } from '@front10/landing-page-book/dist/components';
import styled from 'styled-components';

export const UpgradeConfirmationBodyWrapper = styled.div`
  background-color: white;
  color: var(--dark);
  padding: 16px;
  border-radius: 16px;
  width: 450px;
`;

export const UpgradeConfirmationHeader = styled.h4`
  font-weight: 500;
  border-bottom: 1px solid #eeeeee;
  padding: 10px 0;
  text-align: left;
`;

export const UpgradeConfirmationDescription = styled.div`
  text-align: left;
  color: var(--gray);
  padding: 0 10px;
`;

export const BoldText = styled.span`
  font-weight: 600;
  color: var(--dark);
`;

export const ButtonGroupWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
`;

export const CancelButton = styled(Button)`
  background: #eeeeee;
  margin-right: 20px;
`;